import React from 'react';
import FilterAccordion from './FilterAccordion';
import { FormGroup, FormControlLabel, Checkbox, Slider, RadioGroup, FormControl, Radio, Button, Popover, Typography, Box, useTheme, useMediaQuery } from '@mui/material';

const Filter = ({ values, onChange }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const filterStyles = {
    '& .MuiFormControlLabel-label': {
      fontFamily: 'Montserrat',
      color: '#013D51',
    },
  };

  const categories = [
    { label: "Combattant", value: "Combattant/לחימה" },
    { label: "Communication & Cyber", value: "Communication & Cyber/תקשוב" },
    { label: "Éducation et instruction", value: "Éducation et instruction/חינוך הוראה והדרכה" },
    { label: "Logistique et administration", value: "Logistique et administration/לוגיסטיקה ומנהלה" },
    { label: "Médical", value: "Médical/רפואה" },
    { label: "Parcours d'officier", value: "Parcours d'officier/קצונה ייעודית" },
    { label: "Police", value: "Police/שיטור" },
    { label: "Renseignement", value: "Renseignement/מודיעין" },
    { label: "Ressources humaines", value: "Ressources humaines/משבאי אנוש וכוח אדם" },
    { label: "Secrétariat & Assistance & porte parolat", value: "Secrétariat & Assistance & porte parolat/פקידות, סיוע ודוברות" },
    { label: "Technologique", value: "Technologique/טכנלוגיים" }
  ];

  const genres = ["Homme", "Femme"];
  const volontaires = ["Oui", "Non"];
  const entretiens = ["Oui", "Non"];
  const profiles = ["25", "45", "64", "72", "82", "97"];
  const ivritOptions = ["5", "6", "7", "8"];
  const keshevOptions = ["1", "2", "3", "4", "5"];

  const requirements = [
    { key: 'caregiving', label: 'טיפול באדם – Empathie et relation inter-personelle' },
    { key: 'leadership', label: 'פיקוד – Leadership' },
    { key: 'teamwork', label: 'עבודת צוות – Travail d\'équipe' },
    { key: 'discipline', label: 'התנהגות מסגרתית – Comportement dans un groupe' },
    { key: 'maturity', label: 'בגרות ובשלות – Maturité et Sérénité' },
    { key: 'perseverance', label: 'השקעה והתמדה – Investissement et persévérance' },
    { key: 'InformationProcessing', label: 'עיבוד מידע – Traitement de l\'information' },
    { key: 'management', label: 'ניהול וארגון – Gestion et organisation' },
    { key: 'technicalOperation', label: 'הפעלה טכנית – Maitrise technique' },
    { key: 'perception', label: 'תפיסת מרחב – Perception spatiale' },
    { key: 'instruction', label: 'הדרכה – Instruction' }
  ];

  // Mise à jour des valeurs des filtres
  const handleCategoryChange = (category, checked) => {
    const newCategories = checked
      ? [...(values.categories || []), category]
      : (values.categories || []).filter((item) => item.value !== category.value);
    onChange({ ...values, categories: newCategories });
  };

  const handleGenreChange = (genre, checked) => {
    const newGenres = checked
      ? [...(values.genres || []), genre]
      : (values.genres || []).filter((item) => item !== genre);
    onChange({ ...values, genres: newGenres });
  };

  const handleVolontaireChange = (volontaire, checked) => {
    const newVolontaires = checked
      ? [...(values.volontaires || []), volontaire]
      : (values.volontaires || []).filter((item) => item !== volontaire);
    onChange({ ...values, volontaires: newVolontaires });
  };

  const handleEntretienChange = (entretien, checked) => {
    const newEntretiens = checked
      ? [...(values.entretiens || []), entretien]
      : (values.entretiens || []).filter((item) => item !== entretien);
    onChange({ ...values, entretiens: newEntretiens });
  };

  const handleDaparChange = (value) => {
    onChange({ ...values, dapar: value });
  };

  const handleProfileChange = (profile) => {
    onChange({ ...values, profile });
  };

  const handleRequirementChange = (key, value) => {
    const newRequirements = { ...(values.requirements || {}), [key]: value };
    onChange({ ...values, requirements: newRequirements });
  };

  const handleIvritChange = (ivrit) => {
    onChange({ ...values, ivrit });
  };

  const handleKeshevChange = (keshev) => {
    onChange({ ...values, keshev });
  };

  const handleClearAll = () => {
    onChange({});
  };

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'requirements-popover' : undefined;

  // Vérifie si des notes sont définies
  const hasRequirementsFilter = values.requirements && Object.keys(values.requirements).some(key => values.requirements[key] > 0);

  // Calcul du nombre de filtres actifs
  const numberOfFiltersSelected = [
    (values.categories || []).length > 0,
    (values.genres || []).length > 0,
    (values.volontaires || []).length > 0,
    (values.entretiens || []).length > 0,
    values.dapar && values.dapar !== 50,
    values.profile,
    values.ivrit,
    values.keshev,
    hasRequirementsFilter,
  ].filter(Boolean).length;

  return (
    <div style={{ border: '1px solid #E4E7EB', borderRadius: '30px', padding: "1rem" }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h3 style={{ fontFamily: 'Montserrat', color: '#013D51', fontWeight: '700', fontSize: '1rem', margin: 0 }}>
            FILTRES ({numberOfFiltersSelected})
          </h3>
        </div>
        <div>
          <Button 
            onClick={handleClearAll}
            sx={{
              fontFamily: 'Montserrat',
              fontSize: '0.8rem',
              fontWeight: '500',
              textTransform: 'none',
              padding: 0,
              minWidth: 'auto',
              '&:hover': {
                backgroundColor: 'transparent',
                textDecoration: 'underline',
              },
            }}
          >
            Tout effacer         
          </Button>
        </div>
      </div>

      <hr />
      
      <FilterAccordion title="Catégorie">
        <FormGroup>
          {categories.map((category, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  color="secondary"
                  checked={(values.categories || []).some(c => c.value === category.value)}
                  onChange={(e) => handleCategoryChange(category, e.target.checked)}
                />
              }
              label={category.label}
              sx={filterStyles}
            />
          ))}
        </FormGroup>
      </FilterAccordion>

      <hr />

      <FilterAccordion title="Genre">
        <FormGroup>
          {genres.map((genre, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  color="secondary"
                  checked={(values.genres || []).includes(genre)}
                  onChange={(e) => handleGenreChange(genre, e.target.checked)}
                />
              }
              label={genre}
              sx={filterStyles}
            />
          ))}
        </FormGroup>
      </FilterAccordion>

      <hr />

      <FilterAccordion title="Volontaire (exempté pour raison médicale)">
        <FormGroup>
          {volontaires.map((volontaire, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  color="secondary"
                  checked={(values.volontaires || []).includes(volontaire)}
                  onChange={(e) => handleVolontaireChange(volontaire, e.target.checked)}
                />
              }
              label={volontaire}
              sx={filterStyles}
            />
          ))}
        </FormGroup>
      </FilterAccordion>

      <hr />

      <FilterAccordion title="Poste avec entretien">
        <FormGroup>
          {entretiens.map((entretien, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  color="secondary"
                  checked={(values.entretiens || []).includes(entretien)}
                  onChange={(e) => handleEntretienChange(entretien, e.target.checked)}
                />
              }
              label={entretien}
              sx={filterStyles}
            />
          ))}
        </FormGroup>
      </FilterAccordion>

      <hr />

      <FilterAccordion title="Dapar">
        <FormControl>
          <RadioGroup
            aria-labelledby="radio-dapar-group-label"
            name="radio-dapar-group"
            row
            value={values.dapar || ''}
            onChange={(e) => handleDaparChange(e.target.value)}
          >
            {[...Array(9)].map((_, i) => {
              const val = String(10 + i * 10);
              return (
                <FormControlLabel
                  key={val}
                  value={val}
                  control={<Radio color="secondary" />}
                  label={val}
                  sx={filterStyles}
                />
              );
            })}
          </RadioGroup>
        </FormControl>
      </FilterAccordion>

      <hr />

      <FilterAccordion title="Profil">
        <FormControl>
          <RadioGroup
            aria-labelledby="radio-buttons-group-label"
            name="radio-buttons-group"
            row
            value={values.profile || ''}
            onChange={(e) => handleProfileChange(e.target.value)}
          >
            {profiles.map((profile, index) => (
              <FormControlLabel
                key={index}
                value={profile}
                control={<Radio color="secondary" />}
                label={profile}
                sx={filterStyles}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </FilterAccordion>

      <hr />

      <FilterAccordion title="Simoul Ivrit">
        <FormControl>
          <RadioGroup
            aria-labelledby="radio-ivrit-group-label"
            name="radio-ivrit-group"
            row
            value={values.ivrit || ''}
            onChange={(e) => handleIvritChange(e.target.value)}
          >
            {ivritOptions.map((ivrit, index) => (
              <FormControlLabel
                key={index}
                value={ivrit}
                control={<Radio color="secondary" />}
                label={ivrit}
                sx={filterStyles}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </FilterAccordion>

      <hr />

      <FilterAccordion title="Keshev">
        <FormControl>
          <RadioGroup
            aria-labelledby="radio-keshev-group-label"
            name="radio-keshev-group"
            row
            value={values.keshev || ''}
            onChange={(e) => handleKeshevChange(e.target.value)}
          >
            {keshevOptions.map((keshev, index) => (
              <FormControlLabel
                key={index}
                value={keshev}
                control={<Radio color="secondary" />}
                label={keshev}
                sx={filterStyles}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </FilterAccordion>

      <hr />

      <FilterAccordion title="Notes Yom Hameah">
        <Button
          variant="outlined"
          onClick={handlePopoverOpen}
          sx={{
            fontFamily: 'Montserrat',
            color: '#991FD1',
            borderColor: '#991FD1',
            '&:hover': {
              backgroundColor: '#991FD1',
              color: 'white',
              borderColor: '#991FD1',
            },
          }}
        >
          Définir mes notes {hasRequirementsFilter && '✓'}
        </Button>
        
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handlePopoverClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          PaperProps={{
            style: {
              padding: isMobile ? '0.75rem' : '1rem',
              width: isMobile ? 'calc(100vw - 1rem)' : 'auto',
              maxWidth: isMobile ? 'calc(100vw - 1rem)' : '500px',
              minWidth: isMobile ? 'unset' : '300px',
            }
          }}
          sx={{
            '& .MuiPopover-paper': {
              ...(isMobile && {
                position: 'fixed !important',
                // left: '0.5rem !important',
                // right: '0.5rem !important',
                top: '50% !important',
                transform: 'translateY(-50%) !important',
                margin: '0.5rem',
              })
            }
          }}
        >
          <Typography variant="h6" style={{ 
            fontFamily: 'Montserrat', 
            fontWeight: '600', 
            color: '#013D51', 
            marginBottom: '1rem' 
          }}>
            Mes notes Yom Hameah
          </Typography>
          <Typography variant="body2" style={{ 
            fontFamily: 'Montserrat', 
            color: 'gray', 
            marginBottom: '1rem' 
          }}>
            Saisissez vos notes obtenues au Yom Hameah. Seuls les postes correspondant à vos capacités seront affichés.
          </Typography>
          
          {requirements.map((req) => (
            <Box key={req.key} sx={{ marginBottom: '1.5rem' }}>
              <Typography style={{ 
                fontFamily: 'Montserrat', 
                color: '#013D51', 
                fontSize: '0.9rem',
                marginBottom: '0.5rem',
                fontWeight: '600'
              }}>
                {req.label}
              </Typography>
              <FormControl>
                <RadioGroup
                  row
                  value={(values.requirements && values.requirements[req.key]) || ''}
                  onChange={(e) => handleRequirementChange(req.key, e.target.value || null)}
                >
                  <FormControlLabel
                    value=""
                    control={<Radio color="secondary" size="small" />}
                    label="Non défini"
                    sx={{
                      '& .MuiFormControlLabel-label': {
                        fontFamily: 'Montserrat',
                        fontSize: '0.8rem',
                        color: '#666',
                      },
                    }}
                  />
                  {[1, 2, 3, 4, 5].map((score) => (
                    <FormControlLabel
                      key={score}
                      value={score.toString()}
                      control={<Radio color="secondary" size="small" />}
                      label={score.toString()}
                      sx={{
                        '& .MuiFormControlLabel-label': {
                          fontFamily: 'Montserrat',
                          fontSize: '0.8rem',
                          color: '#013D51',
                        },
                      }}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </Box>
          ))}
          
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
            <Button
              onClick={handlePopoverClose}
              variant="contained"
              sx={{
                backgroundColor: '#013D51',
                fontFamily: 'Montserrat',
                '&:hover': {
                  backgroundColor: '#012a3a',
                },
              }}
            >
              Fermer
            </Button>
          </Box>
        </Popover>
      </FilterAccordion>
    </div>
  );
};

export default Filter;
